module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_8023.ab9b1782.png";